import { module as BaseModule } from "modujs"
import confetti from "canvas-confetti"

export default class extends BaseModule {
  init() {
    this.onPointerEnter = this.onPointerEnter.bind(this)
    this.lastBurst = 0
    this.cooldown =
      Number(this.el.getAttribute("data-confetti-cooldown")) || 1200
    this.particleCount =
      Number(this.el.getAttribute("data-confetti-particles")) || 40
    this.spread = Number(this.el.getAttribute("data-confetti-spread")) || 70
    this.startVelocity =
      Number(this.el.getAttribute("data-confetti-velocity")) || 28
    this.scalar = Number(this.el.getAttribute("data-confetti-scale")) || 0.9
    this.colors = this.getColors()
    this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    )

    this.el.addEventListener("pointerenter", this.onPointerEnter)
  }

  onPointerEnter() {
    if (this.prefersReducedMotion.matches) return

    const now = Date.now()
    if (now - this.lastBurst < this.cooldown) return
    this.lastBurst = now

    const rect = this.el.getBoundingClientRect()
    const originX = (rect.left + rect.width / 2) / window.innerWidth
    const originY = (rect.top + rect.height / 2) / window.innerHeight

    confetti({
      particleCount: this.particleCount,
      spread: this.spread,
      startVelocity: this.startVelocity,
      scalar: this.scalar,
      colors: this.colors,
      origin: { x: originX, y: originY },
    })
  }

  getColors() {
    const customColors = this.el.getAttribute("data-confetti-colors")
    if (customColors) {
      return customColors
        .split(",")
        .map((color) => color.trim())
        .filter(Boolean)
    }

    return ["#EDEBE4", "#1B1B1B", "#C9A44C", "#C0C0C0"]
  }

  destroy() {
    this.el.removeEventListener("pointerenter", this.onPointerEnter)
  }
}
